import { render, staticRenderFns } from "./EditFacility.vue?vue&type=template&id=0a6408a0&scoped=true&lang=html"
import script from "./EditFacility.vue?vue&type=script&lang=js"
export * from "./EditFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6408a0",
  null
  
)

export default component.exports